import classNames from "classnames";
import { Link } from "react-router-dom";

export const TitleBar = ({
  title,
  children,
  isNotMain = false,
}: {
  isNotMain?: boolean;
  title?: string;
  children?: React.ReactNode | string;
}) => (
  <div className="w-full flex pb-6">
    <div
      className={classNames("flex-grow font-bold text-2xl", "text-grayText")}
    >
      {title}
    </div>
    <div className="flex gap-4">{children}</div>
  </div>
);

interface IBreadCrumb {
  link?: string;
  label: string;
}

/**
 * Bread crumbs are arranged in order
 * @param crumbs Array of { link, label } objects
 */
export const BreadCrumbs = ({ crumbs }: { crumbs: IBreadCrumb[] }) => {
  return (
    <div className="space-x-1 text-xs pb-2 font-medium text-primaryColor">
      <span className="hover:text-black underline">
        <Link to={"/"}>Home</Link>
      </span>
      {crumbs.map((crumb, index) => (
        <span key={index}>
          /{" "}
          {crumb.link ? (
            <Link to={crumb.link} className="hover:text-black underline">
              {crumb.label}
            </Link>
          ) : (
            <>{crumb.label}</>
          )}
        </span>
      ))}
    </div>
  );
};
